import { render, staticRenderFns } from "./Promote.vue?vue&type=template&id=1b3de2e0&"
import script from "./Promote.vue?vue&type=script&lang=js&"
export * from "./Promote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports